import { RouteNames } from '$app/router'
import { useRouter } from '$actions/useRouter'

import useReturnToInfo from './useReturnToInfo'

/**
 * Redirect to whatever current URL's `return_to` query parameter.
 */
export const useReturnTo = () => {
  const { redirect } = useRouter()
  const { isValid, return_to } = useReturnToInfo()

  type Options = Parameters<typeof redirect>[1]

  return (fallback: RouteNames, options?: Options) => {
    const destination = return_to || fallback

    // Only redirect to valid route-names
    // otherwise, use fallback
    const target = isValid ? destination : fallback

    redirect(target, options)
  }
}

export default useReturnTo
